// CogniRecommendation.js
import React from "react";
//import "./CogniRecommendation.css";

const RECOMMENDATIONS = [
    {
        title: "Entrenamiento de memoria de trabajo",
        text:
            "Basado en los resultados de la evaluación, se recomienda centrarse en ejercicios de memoria de trabajo. CogniFit ofrece un programa específico para esta habilidad.",
        btnText: "Asignar a paciente",
        btnType: "primary",
    },
    {
        title: "Ejercicios de atención focalizada",
        text:
            "El paciente podría beneficiarse de entrenamientos diarios de 15 minutos para mejorar su capacidad de atención sostenida.",
        btnText: "Asignar a paciente",
        btnType: "primary",
    },
    {
        title: "Seguimiento cognitivo periódico",
        text:
            "Se recomienda realizar una evaluación de seguimiento en 3 meses para monitorizar el progreso y ajustar el plan de entrenamiento si fuera necesario.",
        btnText: "Programar recordatorio",
        btnType: "secondary",
    },
];

const CogniRecommendation = () => (
    <div className="cogni-reco-wrapper">
        <h2 className="cogni-reco-title">Recomendaciones cognitivas personalizadas</h2>
        {RECOMMENDATIONS.map((rec, idx) => (
            <div key={idx} className="cogni-reco-card">
                <h3 className="cogni-reco-card__title">{rec.title}</h3>
                <p className="cogni-reco-card__text">{rec.text}</p>
                <button
                    className={`cogni-btn ${
                        rec.btnType === "primary"
                            ? "cogni-btn--primary"
                            : "cogni-btn--secondary"
                    } cogni-reco-card__btn`}
                >
                    {rec.btnText}
                </button>
            </div>
        ))}
    </div>
);

export default CogniRecommendation;
